import { render, staticRenderFns } from "./CorrectiveActionViewModal.vue?vue&type=template&id=38d6847a"
import script from "./CorrectiveActionViewModal.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports